import React from "react";
import { Button, Col, Container, FormCheck, Modal, Row } from "react-bootstrap";

import classNames from "classnames";

import Loading from "../../../../../../components/Loading";
import { selectFields } from "../../../../../../features/global/globalSlice";
import { useAppSelector } from "../../../../../../hooks/reduxHooks";
import { defaultDateTimeFormat } from "../../../../../../lib/utils";
import { useTournamentContext } from "../../contexts/Tournament";

const BracketChangeModal = (): React.JSX.Element => {
    const {
        showBracketChangeModal: show,
        setShowBracketChangeModal: setShow,
        modalDroppedGames,
        setModalDroppedGames,
        modalOldBracketGames,
        modalDropGamesCount,
        modalChangedAgeLevel,
        setModalChangedAgeLevel,
    } = useTournamentContext();

    const fields = useAppSelector(selectFields);

    return (
        <Modal
            show={show}
            onHide={() => {
                setModalDroppedGames([]);
                setShow(false);
                setModalChangedAgeLevel("");
            }}
            centered
        >
            <Modal.Header>
                <Modal.Title>
                    Changing to this bracket will result in fewer playoff games
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row>
                        <Col>
                            <p>
                                Please select the games you want dropped from
                                the schedule. All other games will have their
                                fields/times copied over to the new bracket.
                                Changing to the new selected bracket, you need
                                to drop at least <b>{modalDropGamesCount}</b> of
                                the{" "}
                                {modalChangedAgeLevel !== "" ? (
                                    <b>{modalChangedAgeLevel}</b>
                                ) : (
                                    ""
                                )}{" "}
                                games below.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {modalOldBracketGames.length === 0 && (
                                <Loading
                                    className={classNames("text-center mb-2")}
                                />
                            )}
                            {modalOldBracketGames.map(g => (
                                <FormCheck
                                    type={"checkbox"}
                                    key={g.id}
                                    id={g.id.toString()}
                                    checked={modalDroppedGames.includes(g.id)}
                                    label={`${g.ageLevel.ageLevel}, ${defaultDateTimeFormat.format(
                                        new Date(g.date),
                                    )}, ${fields.find(f => f.id === g.fieldId)?.diamonds.find(d => d.id === g.diamond)?.name}`}
                                    onChange={e =>
                                        setModalDroppedGames(prev => {
                                            const id = parseInt(e.target.id);
                                            return e.target.checked
                                                ? [...prev, id]
                                                : prev.filter(i => i !== id);
                                        })
                                    }
                                />
                            ))}
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={() => {
                        setModalDroppedGames([]);
                        setShow(false);
                        setModalChangedAgeLevel("");
                    }}
                >
                    No
                </Button>
                <Button
                    variant="success"
                    onClick={() => setShow(false)}
                    disabled={modalDroppedGames.length < modalDropGamesCount}
                >
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BracketChangeModal;
